export default __webpack_public_path__ + "static/media/icon-send2.fbbb414c.svg";